import React, { useEffect, useRef, useState } from "react";
import "./nestedselect.css";
import { BiChevronDown } from "react-icons/bi";

const permissionContainer = {
  paddingLeft: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
};

const permissionCheckBox = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  paddingRight: 10,
};

const MultiNestedSelect = ({ name, options, value, onChange, placeHolder }) => {
  const [state, setState] = useState(false);
  const [option, setOption] = useState(options || []);
  const [selected, setSelected] = useState(value || []);
  const mref = useRef(null);

  useEffect(() => {
    setSelected(value || []);
  }, [value]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (mref.current && !mref.current.contains(event.target)) {
        setState(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mref]);

  const checkItem = (val, subval, subinval) => {
    let check1 = false;

    if (val && !subval && !subinval) {
      check1 = selected.find((item) => {
        return (
          item.item_id.toString().slice(0, 1) ==
          val.item_id.toString().slice(0, 1)
        );
      })
        ? true
        : false;
    }

    if (val && subval && !subinval) {
      check1 = selected.find((item) => {
        let check2 = item?.sub_item?.find((el) => {
          return (
            el.item_id.toString().slice(0, 2) ==
            subval.item_id.toString().slice(0, 2)
          );
        })
          ? true
          : false;
        return check2;
      })
        ? true
        : false;
    }

    if (val && subval && subinval) {
      check1 = selected.find((item) => {
        // console.log('itemitemitemitemitemitem',item)
        let check2 = item?.sub_item?.find((el) => {
          let check3 = el?.sub_item?.find((ej) => {
            let checkId =
              ej.item_id.toString().slice(0, 3) ==
              subinval.item_id.toString().slice(0, 3);
            if (checkId) {
              // console.log(ej);
              return true;
            }

            // let check4 = ej?.permissions?.length ? true : false;
            // return check4;
          });
          return check3;
        })
          ? true
          : false;
        return check2;
      })
        ? true
        : false;
    }

    return check1;
  };

  const checkItem1 = (val, subval, subinval) => {
    let isTrue = false;
    if (selected && selected.length > 0) {
      selected.find((item) => {
        if (val.sub_item) {
          if (
            !subinval &&
            !subval &&
            item?.sub_item &&
            val.value === item.value &&
            val.sub_item.length === item.sub_item.length
          ) {
            isTrue = true;
          }
          item?.sub_item &&
            item.sub_item.find((item1) => {
              if (subval?.sub_item) {
                if (
                  !subinval &&
                  item1?.sub_item &&
                  subval.value === item1.value &&
                  subval.sub_item.length === item1.sub_item.length
                ) {
                  isTrue = true;
                }
                let findSubInVal =
                  item1?.sub_item &&
                  item1.sub_item.find(
                    (item2) => item2.value === subinval?.value
                  );
                if (findSubInVal) {
                  isTrue = true;
                }
              } else if (item1.value === subval?.value) {
                isTrue = true;
              }
            });
        } else if (item.value === val.value) {
          isTrue = true;
        }
      });
    }
    return isTrue;
  };

  const handleParentChange = (val, index) => {
    let tempSel = JSON.parse(JSON.stringify(selected));
    let tempOption = JSON.parse(JSON.stringify(option));
    if (val.sub_item) {
      tempOption[index].show_sub_item = !tempOption[index].show_sub_item;
    } else {
      let findExist =
        tempSel &&
        tempSel.length > 0 &&
        tempSel.find((item) => item.value === val.value);
      if (findExist) {
        tempSel = selected.filter((item) => item.value !== val.value);
      } else {
        tempSel.push({
          item_id: val.item_id,
          label: val.label,
          value: val.value,
          permissions: ["view"],
        });
      }
    }
    analyzeEmpty(tempSel);
    setOption(tempOption);
  };

  const checkPermissionItem = (val, id) => {
    let tempSel = JSON.parse(JSON.stringify(selected));
    let CheckItem = tempSel?.find((itm) => {
      if (itm?.sub_item && itm?.sub_item?.length) {
        return itm?.sub_item?.find((perm1) => {
          if (perm1?.sub_item) {
            let CheckPerm = perm1.sub_item.find((perm2) => {
              return perm2?.item_id == id;
            });
            let findPerm = CheckPerm?.permissions.find((el) => {
              return el == val;
            })
              ? true
              : false;
            return findPerm ? true : false;
          } else {
            return perm1?.permissions?.find((perm3) => {
              return perm3 == val && perm1.item_id == id;
            })
              ? true
              : false;
          }
        })
          ? true
          : false;
      } else {
        // console.log(itm,'0000000000000000000000000000000000')
        return itm?.permissions?.find((perm) => {
          return perm === val && itm.item_id === id;
        })
          ? true
          : false;
      }
    }) ? true : false;
    // console.log(CheckItem,'CheckItemCheckItem',id,'id',val)
    return CheckItem;
  };

  const handlePermissionChange = (val, id) => {
    let tempSel = JSON.parse(JSON.stringify(selected));
    // let tempOption = JSON.parse(JSON.stringify(option));
    tempSel = tempSel.map((el) => {
      let obj = { ...el };
      if (!el?.sub_item?.length && obj.item_id === id) {
        // console.log( obj.item_id ,'thisd si my item id')
        let findInd = el.permissions.findIndex((f) => {
          return f === val;
        });
        if (findInd > -1) {
          // console.log('findIndfindInd',findInd)
          obj.permissions.splice(findInd, 1);
        } else {
          obj.permissions.push(val);
        }
      } else {
        let subItm1 = el?.sub_item?.length
          ? JSON.parse(JSON.stringify(el?.sub_item))
          : null;
        subItm1 =
          subItm1 &&
          subItm1.map((ei) => {
            let obj1 = { ...ei };
            if (!obj1?.sub_item && obj1.item_id == id) {
              let findInd = obj1?.permissions?.findIndex((f) => {
                return f == val;
              });

              if (findInd > -1) {
                obj1.permissions.splice(findInd, 1);
              } else {
                obj1.permissions.push(val);
              }
            } else {
              let subItm2 = obj1?.sub_item?.length ? [...obj1?.sub_item] : [];
              subItm2 =
                subItm2 &&
                subItm2?.map((ej) => {
                  let obj2 = { ...ej };
                  if (!obj2.sub_item && obj2.item_id == id) {
                    let findInd = obj2.permissions.findIndex((f) => {
                      return f == val;
                    });
                    if (findInd > -1) {
                      obj2.permissions.splice(findInd, 1);
                    } else {
                      obj2.permissions.push(val);
                    }
                  }

                  return obj2;
                });
            }
            return obj1;
          });
        obj.sub_item = subItm1;
      }
      // console.log('objobjobj',obj)
      return obj;
    });

    analyzeEmpty(tempSel);
    // setOption(tempOption);
  };

  const handleChild1Change = (val, parentindex, submenu, subindex) => {
    let tempSel = JSON.parse(JSON.stringify(selected));
    let tempOption = JSON.parse(JSON.stringify(option));
    if (submenu.sub_item) {
      tempOption[parentindex].sub_item[subindex].show_sub_item =
        !tempOption[parentindex].sub_item[subindex].show_sub_item;
    } else {
      let findExist =
        tempSel &&
        tempSel.length > 0 &&
        tempSel.find((item) => item.value === val.value);
      let findInExist =
        findExist?.sub_item &&
        findExist.sub_item.find((item1) => item1.value === submenu.value);
      if (findExist && findInExist) {
        let findElseInExist = findExist.sub_item.filter(
          (item1) => item1.value !== submenu.value
        );
        tempSel = tempSel.map((item3) => {
          if (item3.value === val.value) {
            item3.sub_item = findElseInExist;
          }
          return item3;
        });
      } else {
        if (findExist) {
          findExist.sub_item.push({
            item_id: submenu.item_id,
            label: submenu.label,
            value: submenu.value,
            permissions: ["view"],
          });
          tempSel = tempSel.map((item4) => {
            if (item4.value === val.value) {
              item4 = findExist;
            }
            return item4;
          });
        } else {
          tempSel.push({
            item_id: val.item_id,
            label: val.label,
            value: val.value,
            sub_item: [
              {
                item_id: submenu.item_id,
                label: submenu.label,
                value: submenu.value,
                permissions: ["view"],
              },
            ],
          });
        }
      }
    }
    analyzeEmpty(tempSel);
    setOption(tempOption);
  };

  const handleChild2Change = (val, submenu, subinmenu) => {
    let tempSel = JSON.parse(JSON.stringify(selected));
    let tempOption = JSON.parse(JSON.stringify(option));
    let findExist =
      tempSel &&
      tempSel.length > 0 &&
      tempSel.find((item) => item.value === val.value);
    let findSubExist =
      findExist?.sub_item &&
      findExist.sub_item.find((item1) => item1.value === submenu.value);
    let findSubInExist =
      findSubExist?.sub_item &&
      findSubExist.sub_item.find((item1) => item1.value === subinmenu.value);
    if (findExist && findSubExist && findSubInExist) {
      let findElseInExist = findSubExist.sub_item.filter(
        (item1) => item1.value !== subinmenu.value
      );
      findSubExist.sub_item = findElseInExist;
      tempSel = tempSel.map((item3) => {
        if (item3.value === val.value) {
          let newitem = item3.sub_item.map((item5) => {
            if (item5.value === findExist.value) {
              item5 = findSubExist;
            }
            return item5;
          });
          item3.sub_item = newitem;
        }
        return item3;
      });
    } else {
      if (findExist && findSubExist) {
        findSubExist.sub_item.push({
          item_id: subinmenu.item_id,
          label: subinmenu.label,
          value: subinmenu.value,
          sub_item: subinmenu.sub_item,
          permissions: ["view"],
        });
        tempSel = tempSel.map((item4) => {
          if (item4.value === val.value) {
            let newitem = item4.sub_item.map((item5) => {
              if (item5.value === findExist.value) {
                item5 = findSubExist;
              }
              return item5;
            });
            item4.sub_item = newitem;
          }
          return item4;
        });
      } else if (findExist) {
        tempSel = tempSel.map((item6) => {
          if (item6.value === val.value) {
            item6.sub_item.push({
              item_id: submenu.item_id,
              label: submenu.label,
              value: submenu.value,
              sub_item: [
                {
                  item_id: subinmenu.item_id,
                  label: subinmenu.label,
                  value: subinmenu.value,
                  sub_item: subinmenu.sub_item,
                  permissions: ["view"],
                },
              ],
            });
          }
          return item6;
        });
      } else {
        tempSel.push({
          item_id: val.item_id,
          label: val.label,
          value: val.value,
          sub_item: [
            {
              item_id: submenu.item_id,
              label: submenu.label,
              value: submenu.value,
              sub_item: [
                {
                  item_id: subinmenu.item_id,
                  label: subinmenu.label,
                  value: subinmenu.value,
                  sub_item: subinmenu.sub_item,
                  permissions: ["view"],
                },
              ],
            },
          ],
        });
      }
    }

    analyzeEmpty(tempSel);
    setOption(tempOption);
  };

  const analyzeEmpty = (sel) => {    
    let tempSel = JSON.parse(JSON.stringify(sel));
    for (let l = 0; l < 2; l++) {
      for (let i = 0; i < tempSel.length; i++) {
        if (tempSel[i]?.sub_item && tempSel[i].sub_item.length > 0) {
          for (let j = 0; j < tempSel[i].sub_item.length; j++) {
            if (
              tempSel[i].sub_item[j].sub_item &&
              tempSel[i].sub_item[j].sub_item.length === 0
            ) {
              tempSel[i].sub_item.splice(j, 1);
            }
          }
        } else if (tempSel[i]?.sub_item && tempSel[i].sub_item.length === 0) {
          tempSel.splice(i, 1);
        }
      }
    }
    setState(true);
    setSelected(tempSel);
    onChange &&
      onChange({
        name: name || "name",
        value: tempSel,
        permissions: tempSel.permissions,
      });
  };

  const getName = () => {
    let names =
      (selected &&
        selected.length > 0 &&
        selected
          .map((item) => {
            if (item.sub_item) {
              let namesIn = item.sub_item.map((item1) => {
                if (item1.sub_item) {
                  let namesSubIn = item1.sub_item.map((item2) => {
                    return item2.label;
                  });
                  return [item1.label, ...namesSubIn];
                }
                return item1.label;
              });
              return [item.label, ...namesIn];
            }
            return item.label;
          })
          .flat()
          .flat()
          .join(", ")) ||
      placeHolder ||
      "Select";
    return names;
  };

  return (
    <div
      className={`nested-select-box ${state && "nested-select-box-active"}`}
      ref={mref}
    >
      <span
        onClick={() => setState(!state)}
        style={{
          margin: "5px 0px 0px 13px",
          lineHeight: "1.4",
          // border:'1px solid red',
          width: "100%",
          overflowY: "auto",
        }}
      >
        {getName()}
      </span>
      <BiChevronDown
        onClick={() => setState(!state)}
        style={{ fontSize: "25px", color: "hsl(0, 0%, 80%)", margin: "4px" }}
      />
      {state && (
        <div className="nested-select-dropdown">
          {option.map((item, index) => {
            return (
              <>
                <div
                  key={index}
                  className="nested-select-dropdown-item"
                  onClick={() => handleParentChange(item, index)}
                >
                  <div className="d-flex align-items-center">
                    <input
                      readOnly
                      checked={checkItem(item)}
                      type="checkbox"
                      className="nested-select-dropdown-checkbox"
                    ></input>
                    {item.label}
                  </div>
                  {item.sub_item && (
                    <BiChevronDown
                      style={{ fontSize: "25px", color: "hsl(0, 0%, 80%)" }}
                    />
                  )}
                </div>
                <div style={permissionContainer}>
                  {!!item.permissions &&
                    checkItem(item) &&
                    item.permissions.map((el) => {
                      if (el != "view") {
                        return (
                          <div
                            key={Math.random()}
                            style={permissionCheckBox}
                            onClick={() =>
                              handlePermissionChange(el, item.item_id)
                            }
                          >
                            <input
                              readOnly
                              key={Math.random()}
                              checked={checkPermissionItem(el, item.item_id)}
                              type="checkbox"
                              className="nested-select-dropdown-checkbox"
                              style={{ padding: 0 }}
                            ></input>
                            {el}
                          </div>
                        );
                      }
                    })}
                </div>
                {item.sub_item &&
                  item.show_sub_item &&
                  JSON.parse(JSON.stringify(item.sub_item)).map(
                    (submenu, index1) => {
                      return (
                        <>
                          <div
                            className="nested-select-dropdown-item ms-3"
                            key={index1}
                            onClick={() =>
                              handleChild1Change(item, index, submenu, index1)
                            }
                          >
                            <div className="d-flex align-items-center">
                              <input
                                checked={checkItem(item, submenu)}
                                type="checkbox"
                                readOnly
                                className="nested-select-dropdown-checkbox"
                              ></input>
                              {submenu.label}
                            </div>
                            {submenu.sub_item && (
                              <BiChevronDown
                                style={{
                                  fontSize: "25px",
                                  color: "hsl(0, 0%, 80%)",
                                }}
                              />
                            )}
                          </div>
                          <div key={Math.random()} style={permissionContainer}>
                            {!!submenu.permissions &&
                              checkItem(item, submenu) &&
                              JSON.parse(
                                JSON.stringify(submenu.permissions)
                              ).map((ej) => {
                                if (ej != "view") {
                                  return (
                                    <div
                                      key={Math.random()}
                                      style={permissionCheckBox}
                                      onClick={() =>
                                        handlePermissionChange(
                                          ej,
                                          submenu.item_id
                                        )
                                      }
                                    >
                                      <input
                                        readOnly
                                        key={Math.random()}
                                        checked={checkPermissionItem(
                                          ej,
                                          submenu.item_id
                                        )}
                                        type="checkbox"
                                        className="nested-select-dropdown-checkbox"
                                        style={{ padding: 0 }}
                                      ></input>
                                      {ej}
                                    </div>
                                  );
                                }
                              })}
                          </div>
                          {submenu.sub_item &&
                            submenu.show_sub_item &&
                            submenu.sub_item.map((subinmenu, index2) => {
                              return (
                                <>
                                  <div
                                    className="nested-select-dropdown-item ms-5"
                                    key={index2}
                                    onClick={() =>
                                      handleChild2Change(
                                        item,
                                        submenu,
                                        subinmenu
                                      )
                                    }
                                  >
                                    <div className="d-flex align-items-center">
                                      <input
                                        checked={checkItem(
                                          item,
                                          submenu,
                                          subinmenu
                                        )}
                                        readOnly
                                        type="checkbox"
                                        className="nested-select-dropdown-checkbox"
                                      ></input>
                                      {subinmenu.label}
                                    </div>
                                  </div>
                                  <div
                                    style={permissionContainer}
                                    key={Math.random()}
                                  >
                                    {!!subinmenu.permissions &&
                                      checkItem(item, submenu, subinmenu) &&
                                      subinmenu.permissions.map((ek) => {
                                        if (ek != "view") {
                                          return (
                                            <div
                                              key={Math.random()}
                                              style={permissionCheckBox}
                                              onClick={() => {
                                                handlePermissionChange(
                                                  ek,
                                                  subinmenu.item_id
                                                );
                                              }}
                                            >
                                              <input
                                                readOnly
                                                key={Math.random()}
                                                checked={checkPermissionItem(
                                                  ek,
                                                  subinmenu.item_id
                                                )}
                                                type="checkbox"
                                                className="nested-select-dropdown-checkbox"
                                                style={{ padding: 0 }}
                                              ></input>
                                              {ek}
                                            </div>
                                          );
                                        }
                                      })}
                                  </div>
                                </>
                              );
                            })}
                        </>
                      );
                    }
                  )}
              </>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiNestedSelect;
